"use client";

import { useSyncExternalStore } from "react";

/** The value never changes, so there is nothing to subscribe to. */
const subscribe = () => {
  return () => {
    /* no store to unsubscribe from */
  };
};
const getSnapshot = () => true;
const getServerSnapshot = () => false;

/**
 * `false` during SSR and for the client's first (hydrating) render, `true` once
 * hydration has committed. In a client-only render there is no server HTML to
 * match, so it is `true` from the start.
 *
 * Use it to hold back markup driven by client-resolved data. React Query gives
 * hydration no barrier of its own: `useBaseQuery` reads
 * `observer.getOptimisticResult()` directly during render and passes the *same*
 * live getter for both `getSnapshot` and `getServerSnapshot`. A fetch that
 * resolves mid-hydration therefore changes the element tree React is trying to
 * match against the server HTML, which surfaces as React error #418.
 *
 * Passing distinct snapshots here is what makes React itself drive the
 * transition — no effect, and no setState cascade.
 */
export function useIsHydrated(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
